import React from "react";
import { useRouter } from "next/router";
import { AdTypes, SDGI } from "./interfaces";
import { isMobile } from "app/main/functions";
import { usePageConfig } from "app/structure/pageConfigContext";

export interface AdConfig {
    loadAds: boolean;
    adZone: string;
    pageType: string;
    keywords?: string[];
}

const defaultAdConfig: AdConfig = {
    loadAds: true,
    adZone: "boerse",
    pageType: "rubrik"
};

declare const SDG: SDGI;

function initPageParameters(config: AdConfig) {
    SDG.Publisher.setZone(config.adZone);
    SDG.Publisher.setPageType(config.pageType);
    if (config.keywords && config.keywords.length) {
        SDG.Publisher.addKeywords(config.keywords);
    }
}

function registerSlot(slot: string, selector: AdTypes) {
    const node = document.querySelector(`.${selector}`);
    if (node) {
        SDG.Publisher.registerSlot(slot, node as HTMLElement);
    }
    return;
}

function initAdSlots() {
    // mobile
    if (isMobile()) {
        registerSlot("pres", AdTypes.BILLBOARD);
        registerSlot("momrec", AdTypes.MREC_MOBILE);
        registerSlot("sticky", AdTypes.STICKY_MOBILE_FOOTER);
        // desktop
    } else {
        registerSlot("banner", AdTypes.BILLBOARD);
        registerSlot("sky", AdTypes.SKY);
        registerSlot("mrec", AdTypes.MREC);
        registerSlot("mrec_pos2", AdTypes.MREC2);
    }
}

function finilizeAdSlots() {
    SDG.Publisher.loadAllSlots(true);
    SDG.Publisher.finalizeSlots();
}

function placeAdScript(config: AdConfig) {
    const adScript = document.createElement("script");
    adScript.type = "text/javascript";
    adScript.src = "//cdn.stroeerdigitalgroup.de/metatag/live/t-o-wirtschaft/metaTag.min.js";
    adScript.id = "globalAdTagScript";
    adScript.async = true;
    document.head.appendChild(adScript);

    adScript.onload = () => {
        if ((window as any).SDG !== undefined) {
            initPageParameters(config);
            initAdSlots();
            finilizeAdSlots();
        }
    };
}

export const GlobalAdTagScript = () => {
    const router = useRouter();
    const scriptLoading = React.useRef(false);
    const config = usePageConfig();
    const adConfig: AdConfig = config && config.adConfig ? config.adConfig : defaultAdConfig;

    React.useEffect(() => {
        if (adConfig.loadAds && router) {
            if (!scriptLoading.current) {
                placeAdScript(adConfig);
                scriptLoading.current = true;
            }
        }
    }, [router && router.asPath]);

    return null;
};
